const isLocalhost = () => {
  const localEnvs = ['local', 'localhost', '127.0.0.1']
  return localEnvs.some(e => origin.includes(e))
}

export default isLocalhost
